import { render, staticRenderFns } from "./EmployerMatchAgeRequirementMonthsInput.vue?vue&type=template&id=6992b81e&"
import script from "./EmployerMatchAgeRequirementMonthsInput.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchAgeRequirementMonthsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports